import { styled, Box } from '@mui/material'

export const Header = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  flexGrow: 1,
})
